export { default as safeTrim } from './safe-trim';
export { default as isEqualAfterTrim } from './is-equal-after-trim';
